import { Link } from "react-router-dom";
import PageTitle from "../../components/ui/PageTitle";

export default function CompanyPage() {
  return (
    <>
      <div className="page-div">
        <div data-aos="fade-down" className="title-area w-full">
          <PageTitle
            title="Company Name"
            breadcrumb={[
              { name: "home", path: "/" },
              { name: "Search", path: "/searchResults" },
              { name: "Company Name", path: "/companyName" },
            ]}
          />
        </div>

        <div data-aos="fade-up" className="aboutus-wrapper w-full">
          <div className="container-x mx-auto">
            <div className="w-full min-h-[665px] lg:flex lg:space-x-12 pb-10 lg:pb-0">

                <div className="md:w-[570px] w-full md:h-[560px] h-auto rounded overflow-hidden lg:my-0">
                    <img
                    src={`${process.env.PUBLIC_URL}/assets/images/about-events.png`}
                    alt="about"
                    className="w-full h-48 rounded-xl my-5"
                    />

                    <div className="content">
                        <Link to="/contact">
                            <span type="button" class="text-white bg-cyan-900 hover:bg-cyan-800 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2">Contact</span>
                        </Link>

                        <Link to="/contact">
                            <span type="button" class="text-white bg-red-800 hover:bg-red-700 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2">Add to Favorites</span>
                        </Link>
                    </div>
                </div>

                <div className="content flex-1">

                    <div className="content">
                        <span type="button" class="inline-flex text-white bg-red-800 font-medium rounded-full text-sm px-5 py-2.5 text-center me-2 mb-2">Category 1</span>
                        <span type="button" class="inline-flex text-black bg-white border border-gray-300 font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2">Category 2</span>
                        <span type="button" class="inline-flex text-black bg-white border border-gray-300 font-medium rounded-full text-sm px-5 py-2.5 me-2 mb-2">Category 3</span>
                    </div>

                    <h1 className="text-3xl font-medium text-qblack mb-2.5">Description</h1>

                    <p className="text-[15px] text-qgraytwo leading-7 mb-2.5">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
                    </p>

                </div>

            </div>
          </div>
        </div>
      </div>
    </>
  );
}